(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zapped-custom-studio"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zapped-studio-embed')) {
    customElements.define('zapped-studio-embed', class extends HTMLElement {
      connectedCallback() {
        if (this.receiveHeight) return;
        this.receiveHeight = (event) => {
          const frame = this.querySelector('iframe');
          if (!frame || event.origin !== 'https://zapped-custom-studio-test.ailogo.workers.dev' || event.source !== frame.contentWindow) return;
          const data = event.data;
          if (data?.type === 'zapped-studio-scroll-top') { window.scrollTo({ top: 0, behavior: 'auto' }); return; }
          if (data?.type === 'zapped-studio-viewport-request') { this.sendViewport(); return; }
          if (data?.type === 'zapped-studio-checkout') {
            try {
              const url = new URL(data.url);
              const hosts = ['www.zappedheadwear.com', 'zappedheadwear.com', 'zapped-branding-co.myshopify.com', 'checkout.shopify.com', 'shopify.com'];
              if (url.protocol === 'https:' && !url.username && !url.password && !url.port && hosts.includes(url.hostname)) window.location.assign(url.href);
            } catch {}
            return;
          }
          if (data?.type === 'zapped-studio-storefront-login') {
            if (this.dataset.loginUrl) window.location.assign(this.dataset.loginUrl);
            return;
          }
          if (data?.type === 'zapped-studio-storefront-request') {
            if (!/^[A-Za-z0-9_-]{43}$/.test(data.requestId || '') || !/^[A-Za-z0-9_-]{43}$/.test(data.proof || '')) return;
            this.pendingRequest?.abort();
            const requestId = data.requestId;
            const controller = new AbortController();
            this.pendingRequest = controller;
            const timer = setTimeout(() => controller.abort(), 20000);
            const proxy = new URL('/apps/zapped-studio-login', window.location.origin);
            proxy.searchParams.set('mode', 'handoff');
            proxy.searchParams.set('proof', data.proof);
            proxy.searchParams.set('request_id', requestId);
            fetch(proxy.href, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal })
              .then(async (response) => {
                const result = await response.json();
                if (!response.ok && result.status !== 'test_account_required') throw new Error('Connection failed');
                if (this.isConnected) frame.contentWindow.postMessage({ type: 'zapped-studio-storefront-result', requestId, status: result.status, code: result.code }, event.origin);
              })
              .catch(() => {
                if (this.isConnected) frame.contentWindow.postMessage({ type: 'zapped-studio-storefront-result', requestId, status: 'connection_failed' }, event.origin);
              })
              .finally(() => { clearTimeout(timer); if (this.pendingRequest === controller) this.pendingRequest = null; });
            return;
          }
          if (!data || data.type !== 'zapped-studio-height'  || typeof data.height !== 'number' || !Number.isFinite(data.height)) return;
          const height = Math.max(400, Math.min(30000, Math.ceil(data.height)));
          if (frame.height !== String(height)) frame.height = String(height);
        };
        this.sendViewport = () => {
          cancelAnimationFrame(this.viewportFrame);
          this.viewportFrame = requestAnimationFrame(() => {
            const frame = this.querySelector('iframe'); if (!frame) return;
            const rect = frame.getBoundingClientRect(), top = Math.max(0, rect.top), bottom = Math.min(window.innerHeight, rect.bottom);
            if (bottom <= top) return;
            frame.contentWindow.postMessage({ type: 'zapped-studio-viewport', height: bottom - top, center: (top + bottom) / 2 - rect.top }, 'https://zapped-custom-studio-test.ailogo.workers.dev');
          });
        };
        window.addEventListener('scroll', this.sendViewport, { passive: true });
        window.addEventListener('resize', this.sendViewport);
        window.addEventListener('message', this.receiveHeight);
        this.announceReady = () => this.querySelector('iframe')?.contentWindow.postMessage({ type: 'zapped-studio-storefront-ready' }, 'https://zapped-custom-studio-test.ailogo.workers.dev');
        this.querySelector('iframe')?.addEventListener('load', this.announceReady);
        this.announceReady();
        this.sendViewport();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.sendViewport);
        window.removeEventListener('resize', this.sendViewport);
        cancelAnimationFrame(this.viewportFrame);
        this.querySelector('iframe')?.removeEventListener('load', this.announceReady);
        this.pendingRequest?.abort();
        this.pendingRequest = null;
        window.removeEventListener('message', this.receiveHeight);
        this.receiveHeight = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
